import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import rewardApi from "../../services/rewardApi";
import { showErrorSnackbar, showSuccessSnackbar } from "./snackbarSlice";

export const fetchUserPointsAndRewards = createAsyncThunk("reward/fetchUserPointsAndRewards", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await rewardApi.getUserPointsAndRewards(data);
        if(response.status === 0){
            return response?.data;
        }else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const fetchUserRewards = createAsyncThunk("reward/fetchUserRewards", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await rewardApi.getUserRewards(data);
        if(response.status === 0){
            return response?.data?.rewards;
        }else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const claimReward = createAsyncThunk("reward/claimReward", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await rewardApi.claimReward(data);
        dispatch(fetchUserPointsAndRewards({ seasonId: data?.seasonId }))
        dispatch(fetchUserRewards({ seasonId: data?.seasonId }))
        if(response.status === 0){
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({title: error?.message}));
        return rejectWithValue(error.message);
    }
});

export const updatePurchasedPointsStatus = createAsyncThunk('payment/updatePurchasedPointsStatus', async (data, { rejectWithValue, dispatch }) => {
    try {
        const _dataToPass = {...data};
        if(_dataToPass?.seasonId) {
            delete _dataToPass?.seasonId
        }
        
        const response = await rewardApi.updatePurchasedPointsStatus(_dataToPass);
        if (response.status === 0) {
            // update user-info
            dispatch(fetchUserPointsAndRewards({ seasonId: data?.seasonId }));
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            return response?.data; // Return the response data on success
        } else {
            // dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

export const signUpForUpdates = createAsyncThunk("reward/signUpForUpdates", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await rewardApi.signUpForUpdates(data);
        if(response.status === 0){
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({title: error?.message}));
        return rejectWithValue(error.message);
        
    }
});

export const resendUpdateVerificationCode = createAsyncThunk("reward/resendUpdateVerificationCode", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await rewardApi.resendUpdateVerificationCode(data);
        if(response.status === 0){
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({title: error?.message}));
        return rejectWithValue(error.message);
        
    }
});

export const optInForUpdates = createAsyncThunk("reward/optInForUpdates", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await rewardApi.optInForUpdates(data);
        if(response.status === 0){
            dispatch(showSuccessSnackbar({title: response?.data?.message}))
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({title: error?.message}));
        return rejectWithValue(error.message);
        
    }
});

// export const resendUpdateVerificationCode = createAsyncThunk('reward/resendUpdateVerificationCode',)

export const buyPoints = createAsyncThunk("reward/purchasePoints", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await rewardApi.buyPoints(data);
        if(response.status === 0){
            // dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            return response?.data?.paymentIntent;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

const rewardSlice= createSlice({
    name : "reward",
    initialState : {
        rewards: [],
        isLoading: false,
        error: null,
        rewardsLoading: true,
        claimRewardLoading: true,
        buyPoints: null,
        userPointsAndRewards: null,
    },
    reducers: {
        clearPurchasePointIntent: (state) => {
            state.buyPoints = null;
        },
        updateUserPoints: (state, action) => {
            const { userTotalAvailablePoints, userTotalEarnedPoints } = action.payload;
            if(state.userPointsAndRewards) {
                if(userTotalAvailablePoints !== undefined){
                    state.userPointsAndRewards.userTotalAvailablePoints = userTotalAvailablePoints;
                }
                if(userTotalEarnedPoints !== undefined){
                    state.userPointsAndRewards.userTotalEarnedPoints = userTotalEarnedPoints;
                }
            }
        }
    },  
    extraReducers: (builder) => {
        handleAsyncThunk(builder, fetchUserRewards, "rewards", "error", "rewardsLoading");
        handleAsyncThunk(builder, claimReward, "claimReward", "error", "claimingReward");
        handleAsyncThunk(builder, fetchUserPointsAndRewards, "userPointsAndRewards", "error", "isLoading");
        handleAsyncThunk(builder, signUpForUpdates, "signUpForUpdates", "error", "isSignupLoading");
        handleAsyncThunk(builder, resendUpdateVerificationCode, "resendUpdateVerificationCode", "error", "isResendingVerificationCode");
        handleAsyncThunk(builder, optInForUpdates, "optInForUpdates", "error", "isOptingInForUpdates");
        handleAsyncThunk(builder, buyPoints, "buyPoints", "error", "isPurchasingPoints");
        handleAsyncThunk(builder, updatePurchasedPointsStatus, "updatePurchasedPointsStatus", "error", "isUpdatingPurchasePointStatus");
    },
});

export const { clearPurchasePointIntent, updateUserPoints } = rewardSlice.actions;

export default rewardSlice.reducer;